export default __webpack_public_path__ + "static/media/formsonclick.7802600f.svg";